import { areRequestParamsEquals } from './utils';
import type { RequestResponse, RequestParams, CachedRequest } from './types';

let requests: CachedRequest[] = [];

function getCachedResponse(params: RequestParams) {
  const request = requests.find(r => areRequestParamsEquals(r.params, params));

  if (request) {
    return request.response;
  }

  return undefined;
}

function getCachedRequests() {
  // return new array to avoid cache mutation from external modules
  return [...requests];
}

function addResponse<T>(response: RequestResponse<T>, params: RequestParams): void {
  requests.unshift({
    response,
    params
  });
}

function removeRequests(url: string | RegExp) {
  if (typeof url === 'string') {
    requests = requests.filter(request => request.params.url.indexOf(url) === -1);
  } else {
    requests = requests.filter(request => !request.params.url.match(url));
  }
}

function reset() {
  requests = [];
}

export default {
  getCachedResponse,
  getCachedRequests,
  addResponse,
  removeRequests,
  reset
};
